export const companySizeRangeValues = [2, 50, 500, 1000, 1001];

export const TENURE = {
  MONTH: 'month',
  YEAR: 'year',
} as const;
